<template>
  <div class="privacy">
    <h1>{{ $city.name }}健檢預約平台 隱私權保護規範</h1>
    <p>
      感謝您使用「{{
        $city.name
      }}健檢預約平台」（以下簡稱本平台），為了讓您能夠安心的使用本平台的各項服務與資訊，特此向您說明本平台的隱私權保護規範，以保障您的權益，請您詳閱下列內容：
    </p>

    <h2>一、隱私權保護政策的適用範圍</h2>
    <p>
      隱私權保護政策內容，包括本平台如何處理在您使用平台服務時蒐集到的個人識別資料。隱私權保護規範不適用於本平台以外的相關連結平台，也不適用於非本平台所委託或參與管理的人員。
    </p>

    <h2>二、個人資料的蒐集、處理及利用方式</h2>
    <p>
      （一）當您使用本平台並進行預約時，本局將視服務內容請您提供必要的個人資料，且原則上於蒐集個人資料之特定目的必要範圍內處理或利用您的個人資料。
    </p>
    <p>
      （二）本平台在您使用時，會保留您所提供的姓名及聯絡方式等，做為未來提供您各項篩檢邀約、問卷調查或相關公共衛生業務推動使用。
    </p>
    <p>
      （三）於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的 IP
      位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為增進平台服務的參考依據，此記錄為內部應用，絕不對外公布。
    </p>
    <p>
      （四）為提供精確的服務，本局會將收集的問卷調查內容進行統計與分析（排除個人機敏資料），分析結果之統計數據或說明文字呈現，除供內部研究外，會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。
    </p>

    <h2>三、資料之保護</h2>
    <p>
      （一）本平台主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護平台及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。
    </p>
    <p>
      （二）如因其他公共衛生業務必需要有委託本平台提供服務時，本平台亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。
    </p>

    <h2>四、與第三人共用個人資料之政策</h2>
    <p>
      （一）本平台絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據者，不在此限。
    </p>
    <p>（二）前項但書之情形包括但不限於下列各款：</p>
    <ul>
      <li>經由您同意。</li>
      <li>法律明文規定。</li>
      <li>為維護國家安全或增進公共利益所必要。</li>
      <li>為免除您生命、身體、自由或財產上之危險。</li>
      <li>
        在本局監督下，公務機關或學術研究機構基於公共利益為統計或學術研究而有必要，且資料經過提供者處理後或經蒐集者依其揭露方式無從識別特定之當事人。
      </li>
      <li>
        當您在本平台的行為，違反本平台的服務條款或可能損害或妨礙本平台權益或導致任何人遭受損害時，經本平台研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。
      </li>
      <li>有利於您的權益。</li>
    </ul>
    <p>
      （三）本平台委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。
    </p>

    <h2>五、隱私權保護政策之修正</h2>
    <p>
      本平台有關個人隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於平台上。
    </p>
  </div>
</template>

<script>
import _ from "lodash";

const shiftCharCode = (Δ) => (c) => String.fromCharCode(c.charCodeAt(0) + Δ);
export default {
  name: "Privacy",
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.privacy {
  padding: 30px;
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  p {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  ul {
    margin-left: 20px;
  }
  li {
    font-size: 1rem;
    margin-bottom: 10px;
  }
}
</style>
